import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import { ARCHIVE } from "common/viewContent";
import * as Path from "routes/Path/index";
import { toast } from "react-toastify";
import Table from "components/Table";
import Columns from "./Columns";
import { removeArchiveUser, getArchiveUserList } from "store/actions";
import { Link } from "react-router-dom";
import ConfirmModal from "components/Modals/ConfirmModal";
const List = () => {
  const dispatch = useDispatch();
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  const {
    ARCHIVE: USER,
    loading,
    totalCount,
  } = useSelector((state) => state.ArchiveUser);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [confirmModal, setConfirmModal] = useState(false);
  const [search_text, setSearch_text] = useState();
  const [unarchiveId, setUnarchiveId] = useState(null);
  const [archiveList, setArchiveList] = useState();
  const [filter, setFilter] = useState({
    pageNo: currentPage,
    limit: pageSize,
    search_text: "",
  });

  
  const fetchData = async (filter) => {
    const payload = {
      ...filter,
      page: filter?.pageNo,
      record_count: filter?.limit,
     // user_role: "2",
    };
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          setArchiveList(res);
        }
      };
      dispatch(getArchiveUserList({ data: payload, callback }));
    } catch (error) {
      console.error(error, "<===err");
    }
  };

  useEffect(() => {
    fetchData(filter);
    setcolumns(
      Columns({
        currentPage: filter?.pageNo,
        pageSize,
        unarchiveHandler,
      })
    );
  }, [filter]);

  const onClickFilter = (e) => {
    e?.preventDefault();
    setFilter({
      ...filter,
      pageNo: 1,
      limit: pageSize,
      search_text: search_text,
    });
  };
  const handleTableChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const clearFilter = () => {
    setFilter((pre) => ({
      ...pre,
      pageNo: 1,
      search_text: "",
     // user_role: "",
    }));
    setSearch_text("");
  };
  const unarchiveHandler = (id) => {
    setConfirmModal(true);
    setUnarchiveId(id);
  };

  const handleunarchiveConfirm = (event) => {
    event.preventDefault();
    const callback = (err, res) => {
      console.log("error-->", err);
      if (err) {
        toast.error(err);
      } else {
        console.log("response-->", res);
        toast.success(res.message);
        fetchData(filter);
      }
    };
    dispatch(
      removeArchiveUser({
        data: { id: unarchiveId},
        callback,
      })
    );
    setConfirmModal(false);
    setUnarchiveId(null);
  };

  return (
    <>
      {confirmModal && (
        <ConfirmModal
          show={confirmModal}
          handleClose={() => setConfirmModal(false)}
          title={"Confirmation"}
          content={"Are you sure you want to Unarchive this User"}
          handleConfirm={handleunarchiveConfirm}
          loading={""}
        />
      )}
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <Helmet title={ARCHIVE.CURRENT_MODULE} />
      <section className="section">
        <div className="section-header">
          <h1>{ARCHIVE.CURRENT_MODULE}</h1>
          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.dashboard}>Dashboard</Link>
            </div>
            <div className="breadcrumb-item">{ARCHIVE.CURRENT_MODULE} </div>
          </div>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">{ARCHIVE.TOP_CONTENT}</h2>
                </div>
              </div>
              <div className="col-12">
                <form onSubmit={onClickFilter}>
                  <div className="card-header">
                    <div className="col-lg-4 col-sm-12 col-md-12 my-2 px-0">
                      <input
                        className="form-control"
                        name="search_text"
                        onChange={(e) => setSearch_text(e.target.value)}
                        value={search_text}
                        placeholder="Search using name, email..."
                      />
                    </div>
                  </div>
                  <div className="col-12 my-2 gap-4 ">
                    <div className="d-flex gap-4">
                      <button type="submit" className="btn btn-primary btn-lg">
                        Search
                      </button>
                      <button
                        onClick={() => clearFilter()}
                        type="button"
                        className="btn btn-primary btn-lg"
                      >
                        Clear Search
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {!loading && USER?.users?.length > 0 && (
            <Table
              data={USER?.users}
              columns={columns}
              setFilter={setFilter}
              handleTableChange={handleTableChange}
              totalCount={totalCount}
              filter={filter}
            />
          )}
          {!loading && USER?.length === 0 && (
            <p style={{ textAlign: "center" }}>No Archive user Found</p>
          )}
        </div>
      </section>
    </>
  );
};
export default List;
